var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0717 8.2617C16.0717 12.3367 13.1134 16.1534 9.07169 17.27C8.79669 17.345 8.49667 17.345 8.22167 17.27C4.18001 16.1534 1.22168 12.3367 1.22168 8.2617V4.60336C1.22168 3.92002 1.73836 3.14503 2.38003 2.88669L7.02167 0.986719C8.06334 0.561719 9.23834 0.561719 10.28 0.986719L14.9217 2.88669C15.555 3.14503 16.08 3.92002 16.08 4.60336L16.0717 8.2617Z",
    stroke: "#344054",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.64714 9.41146C9.56761 9.41146 10.3138 8.66527 10.3138 7.74479C10.3138 6.82432 9.56761 6.07812 8.64714 6.07812C7.72666 6.07812 6.98047 6.82432 6.98047 7.74479C6.98047 8.66527 7.72666 9.41146 8.64714 9.41146Z",
    stroke: "#344054",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.64746 9.41211V11.9121",
    stroke: "#344054",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.63ec992eedf369dee9930a2b1bc25306.svg";
export { ForwardRef as ReactComponent };